import { IconType } from "react-icons/lib";
import { FaInfoCircle, FaCheckCircle } from "react-icons/fa";
import { RiErrorWarningFill } from "react-icons/ri";
import { MdDangerous } from "react-icons/md";
import classNames from "classnames";
import { Severity } from "../../types";

interface InfoChipProps {
  severity: Severity;
  content: string;
}

const getColorAndIconBySeverity = (severity: Severity): [string, IconType] => {
  switch (severity) {
    case Severity.INFO:
      return ["bg-blue-100 text-blue-600 border-blue-500", FaInfoCircle];
    case Severity.WARN:
      return [
        "bg-yellow-100 text-yellow-700 border-yellow-500",
        RiErrorWarningFill,
      ];
    case Severity.SUCCESS:
      return ["bg-green-100 text-green-700 border-green-500", FaCheckCircle];
    case Severity.DANGER:
      return ["bg-red-100 text-red-700 border-red-500", MdDangerous];
    default:
      return ["bg-gray-100 text-gray-700 border-gray-500", MdDangerous];
  }
};

const InfoChip: React.FC<InfoChipProps> = ({ severity, content }) => {
  const [colorsClasses, Icon] = getColorAndIconBySeverity(severity);
  const classes = classNames(
    colorsClasses,
    "flex gap-2 items-center p-2 rounded-md border"
  );
  return (
    <div className={classes}>
      <Icon className="w-5 h-5" />
      <div>{content}</div>
    </div>
  );
};

export default InfoChip;
